import { render, staticRenderFns } from "./courseLayout.vue?vue&type=template&id=70b245f8&scoped=true"
import script from "./courseLayout.vue?vue&type=script&lang=js"
export * from "./courseLayout.vue?vue&type=script&lang=js"
import style0 from "./courseLayout.vue?vue&type=style&index=0&id=70b245f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b245f8",
  null
  
)

export default component.exports